import {BaseContainerModel} from '../base-container.model';
import { 
  bl_fi_cpcommerce_attrib_child_link_RowClass, bl_fi_cpcommerce_attrib_child_link_RowInterface, 
  bl_fi_mst_attribute_set_hdr_RowClass, 
  bl_fi_mst_item_attribute_child_link_RowClass, 
  bl_fi_mst_item_attribute_child_link_RowInterface
} 
from '../../dbschema';

export class CPCommerceAttribChildLinkModel extends BaseContainerModel {
  bl_fi_cpcommerce_attrib_child_link: bl_fi_cpcommerce_attrib_child_link_RowInterface = new bl_fi_cpcommerce_attrib_child_link_RowClass();
  bl_fi_mst_item_attribute_child_link: bl_fi_mst_item_attribute_child_link_RowInterface = new bl_fi_mst_item_attribute_child_link_RowClass();
  bl_fi_mst_attribute_set_hdr: bl_fi_mst_attribute_set_hdr_RowClass[] = [];
}

export class CPCommerceAttribChildLinkContainerModel extends BaseContainerModel {
  bl_fi_cpcommerce_attrib_child_link: bl_fi_cpcommerce_attrib_child_link_RowInterface = new bl_fi_cpcommerce_attrib_child_link_RowClass();
}

export class postQueryMstAttributeChildLink extends BaseContainerModel {
  bl_fi_mst_item_attribute_child_link: bl_fi_mst_item_attribute_child_link_RowInterface = new bl_fi_mst_item_attribute_child_link_RowClass();
  bl_fi_mst_attribute_set_hdrs: bl_fi_mst_attribute_set_hdr_RowClass[] = [];
}
